import { CanceledError, type AxiosInstance } from "axios"
import { getSessionToken } from "core/hooks/use-session-key"

export const MISSING_SESSION_TOKEN_MESSAGE =
  "No Seam session token; request skipped"

/**
 * Attaches the console session token to every request, read at request time
 * so a refreshed session is picked up. With no usable token the request is
 * cancelled before it leaves the browser instead of being sent as
 * `Authorization: Bearer null`.
 */
export const attachSessionAuthorization = (axios: AxiosInstance): void => {
  axios.interceptors.request.use((config) => {
    const sessionToken = getSessionToken()
    if (sessionToken == null) {
      throw new CanceledError(MISSING_SESSION_TOKEN_MESSAGE)
    }
    config.headers.Authorization = `Bearer ${sessionToken}`
    return config
  })
}
